/**
 * User-facing validation messages for the Documents tab "Trigger RPA"
 * button's disabling conditions (see `documents.tsx`).
 *
 * Each key maps 1:1 to a condition that can disable the button, so the same
 * message can be reused in tooltips, banners, toasts, or help text anywhere
 * in the app.
 *
 * @module documentRpaValidationMessages
 */
export enum DocumentRpaValidationMessages {
  // A document RPA run is already in progress
  RPA_IN_PROGRESS = "RPA run in progress",

  // A prior document write-back is in progress or queued
  DOCUMENT_WRITE_BACK_IN_PROGRESS = "Document write-back in progress",

  // No J-codes are present on the order
  NO_J_CODES = "No J-codes available",

  // Any CPT row has an invalid value on a save-blocking field
  CPT_TABLE_HAS_ERRORS = "Invalid CPT table values",

  // The org's health-care-facility data is still loading
  FACILITY_DATA_LOADING = "Facility data loading in progress",
}
